import React, { useState } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CTabContent,
} from '@coreui/react-pro'
import { Button, Divider } from 'antd'
import { useExchangerTransfer } from './hooks'
import { path } from '../../../../libs'
import { RejectModal } from '../atoms/rejectModal'
import { submitStatus } from './model'
import { RollbackModal } from '../atoms/rollbackModal'
import { CheckCircleOutlined, CloseSquareOutlined } from '@ant-design/icons'
import { formatDigits } from '../../../../libs/utils'

export const ExchangerTransferDetail = () => {
  const [isModalVisible, setIsModalVisible] = useState({
    isRollback: false,
    isReject: false,
  })

  const { exchangerTransfer } = useExchangerTransfer()

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Exchanger transfer</strong>
      </CCardHeader>
      <CCardBody>
        <CTabContent className="pt-3">
          {exchangerTransfer.status === 'STATUS_WAITING_FOR_APPROVE' && (
            <>
              <Button
                style={{ backgroundColor: '#73d13d', marginRight: '10px' }}
                onClick={() => {
                  if (window.confirm('Are you sure?')) {
                    submitStatus({
                      requestId: exchangerTransfer.id,
                      status: 'STATUS_COMPLETED',
                    })
                  }
                }}
              >
                Accepted
              </Button>
              <Button
                type="primary"
                danger
                onClick={() =>
                  setIsModalVisible((prev) => ({
                    ...prev,
                    isReject: true,
                  }))
                }
              >
                Reject
              </Button>
              <Divider />
            </>
          )}
          {exchangerTransfer.status === 'STATUS_COMPLETED' && (
            <>
              <Button
                type="primary"
                onClick={() =>
                  setIsModalVisible((prev) => ({
                    ...prev,
                    isRollback: true,
                  }))
                }
              >
                Rollback
              </Button>
              <Divider />
            </>
          )}
          <div className="mt-2">
            <span className="text-muted">id:</span> {exchangerTransfer.id}
          </div>
          <div className="mt-2">
            <span className="text-muted">Created at:</span>{' '}
            {exchangerTransfer.humanCreatedAt}
          </div>
          <div className="mt-2">
            <span className="text-muted">Updated at:</span>{' '}
            {exchangerTransfer.humanUpdatedAt}
          </div>
          <div className="mt-2">
            <span className="text-muted">Status:</span>{' '}
            {exchangerTransfer.status}
          </div>
          <div
            style={{
              display: exchangerTransfer.rejectReason !== '' ? 'block' : 'none',
            }}
            className="mt-2"
          >
            <span className="text-muted">Reject reason:</span>{' '}
            {exchangerTransfer.rejectReason}
          </div>
          <div
            style={{
              display:
                exchangerTransfer.rollbackReason !== '' ? 'block' : 'none',
            }}
            className="mt-2"
          >
            <span className="text-muted">Rollback reason:</span>{' '}
            {exchangerTransfer.rollbackReason}
          </div>
          <div className="mt-2">
            <span className="text-muted">Manager:</span>{' '}
            {exchangerTransfer.manager?.fullName}
          </div>
          <div className="mt-2">
            <span className="text-muted">Exchanger amount: </span>
            {formatDigits(Number(exchangerTransfer.sourceAmount))}{' '}
            {exchangerTransfer.sourceCurrency}
          </div>
          <div className="mt-2">
            <span className="text-muted">Client amount:</span>{' '}
            {formatDigits(Number(exchangerTransfer.destinationAmount))}{' '}
            {exchangerTransfer.destinationCurrency}
          </div>
          <div className="mt-2">
            <span className="text-muted">Note:</span> {exchangerTransfer.note}
          </div>
          <Divider />
          <div className="mt-2">
            <strong>Client info</strong>
          </div>
          <div className="mt-2">
            <span className="text-muted">Client id:</span>{' '}
            <a
              href={path.clients.details(
                String(exchangerTransfer.client.clientId),
              )}
              target="_blank"
            >
              {exchangerTransfer.client.clientId}
            </a>
          </div>
          <div className="mt-2">
            <span className="text-muted">Client name:</span>{' '}
            {exchangerTransfer.client.fullName}
          </div>
          <div className="mt-2">
            <span className="text-muted">Email:</span>{' '}
            {exchangerTransfer.client.email}
          </div>
          <div className="mt-2">
            <span className="text-muted">Account mt login:</span>{' '}
            {exchangerTransfer.account.mtLogin}
          </div>
          <div className="mt-2">
            <span className="text-muted">Account balance:</span>{' '}
            {formatDigits(exchangerTransfer.account.balance)}
          </div>
          <div className="mt-2">
            <span className="text-muted">Account currency:</span>{' '}
            {exchangerTransfer.account.currency}
          </div>
          <div className="mt-2">
            <span className="text-muted">Is test: </span>
            {exchangerTransfer.client.isTest ? (
              <CheckCircleOutlined className={'text-success'} />
            ) : (
              <CloseSquareOutlined className={'text-danger'} />
            )}
          </div>
          <Divider />
          <div className="mt-2">
            <strong>Exchanger info</strong>
          </div>
          <div className="mt-2">
            <span className="text-muted">Exchanger id:</span>{' '}
            <a
              href={path.exchangers.edit(
                String(exchangerTransfer.exchanger.id),
              )}
              target="_blank"
            >
              {exchangerTransfer.exchanger.id}
            </a>
          </div>
          <div className="mt-2">
            <span className="text-muted">Exchanger name:</span>{' '}
            {exchangerTransfer.exchanger.name}
          </div>
          <div className="mt-2">
            <span className="text-muted">Exchanger owner:</span>{' '}
            <a
              href={path.clients.details(
                String(exchangerTransfer.exchanger.owner.clientId),
              )}
              target="_blank"
            >
              {exchangerTransfer.exchanger.owner.fullName}
            </a>
          </div>
          <div className="mt-2">
            <span className="text-muted">Exchanger balance:</span>{' '}
            {exchangerTransfer.exchanger.balance}
          </div>
        </CTabContent>
      </CCardBody>
      <RollbackModal
        id={exchangerTransfer.id}
        isVisible={isModalVisible.isRollback}
        onClose={() =>
          setIsModalVisible((prev) => ({
            ...prev,
            isRollback: false,
          }))
        }
      />
      <RejectModal
        id={exchangerTransfer.id}
        isVisible={isModalVisible.isReject}
        onClose={() =>
          setIsModalVisible((prev) => ({
            ...prev,
            isReject: false,
          }))
        }
      />
    </CCard>
  )
}
